import * as axios from 'axios'

function upload (formData) {
    console.log('upload', formData)

    console.log('enquiryUUID', formData.get('objectReferenceId'))

    formData.getAll('files').forEach((file) => {
        console.log('file', file)

        // formData.append('objectReferenceId', objectReferenceId)
        // formData.append('dateReference', dateReference)
        // formData.append('description', description)

        // axios.uploadDocument('/Request/AppendRequestDocument', formData.get('objectReferenceId'), dateString, description, formData)
        //     .then((response) => {
        //         console.log('response', response)
        //         return response.data
        //     })

        axios.post('/Request/AppendRequestDocument', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => Promise.resolve(response))
            .catch(error => Promise.reject(error))
    })

    // let dateString = data.file.lastModifiedDate.toLocaleString('en-GB', { timeZone: 'UTC' })
    // dateString = dateString.replace(',', '')

    console.log('this', this)
    console.log('store', this.$store)

    // axios.uploadDocument('/Request/AppendRequestDocument', formData.get('enquiryUUID'), dateString, doc.description, doc.data.data)
    //     .then((response) => {
    //         console.log('response', response);
    //         return response.data;
    //     });

    // return axios.post(url, formData)
    //     // get data
    //     .then(response => response.data)
    //     // add url field
    //     .then(data => data.map((image) => Object.assign({}, image, { url: `${BASE_URL}/images/${image.id}` })))

    // axios.uploadDocument('/Request/AppendRequestDocument', state.enquiryUUID, dateString, doc.description, doc.data.data)
    //     .then(response => {
    //         resolve({
    //             id: response.data.requestDocumentId,
    //             versionStamp: response.data.requestDocumentVersionStamp,
    //             name: doc.data.file.name,
    //             contentType: doc.data.file.type,
    //             icon: doc.icon,
    //             dataSource: doc.dataSource,
    //             data: doc.data,
    //             loading: 3,
    //             deleting: doc.deleting,
    //             photoTaken: doc.data.file.lastModifiedDate,
    //             description: doc.description
    //         })
    //     }).catch(err => {
    //         reject(err)
    //     })
}

export { upload }



// WEBPACK FOOTER //
// ./src/mixins/shared/files-upload.service.js